import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddMember = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.60004 4.53333C4.60004 5.33782 4.91962 6.10936 5.48848 6.67822C6.05734 7.24708 6.82888 7.56666 7.63337 7.56666C8.43785 7.56666 9.20939 7.24708 9.77825 6.67822C10.3471 6.10936 10.6667 5.33782 10.6667 4.53333C10.6667 3.72884 10.3471 2.9573 9.77825 2.38844C9.20939 1.81958 8.43785 1.5 7.63337 1.5C6.82888 1.5 6.05734 1.81958 5.48848 2.38844C4.91962 2.9573 4.60004 3.72884 4.60004 4.53333V4.53333Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 14.5C2 13.0059 2.59351 11.5731 3.64996 10.5166C4.70642 9.46018 6.13928 8.86667 7.63333 8.86667C8.3772 8.86667 9.1059 9.0138 9.78053 9.29194",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.49901V14.501M14.501 12L9.49896 12",
			stroke: "currentColor",
			strokeWidth: .937874,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAddMember;
